import React from 'react';

interface IProps {
  style?: any;
}

const SectionDivider: React.FC<IProps> = ({ style }: IProps) => {
  return (
    <div style={{ height: "4px", backgroundColor: "#6B76871F", ...style }} />
  );
};

export default SectionDivider;